<template>
  <div
    class="inline-flex w-full items-start space-x-2 rounded-lg py-2.5 px-2 leading-[17px] lg:space-x-3 lg:px-3.5"
    :class="bgColor"
  >
    <img :src="icon()" loading="lazy" />
    <div class="text-sm text-white">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "info",
    },
    color: {
      type: String,
      default: "success",
    },
  },
  computed: {
    bgColor() {
      switch (this.color) {
        case "success":
          return "bg-success";
        case "error":
          return "bg-error error-message";
        default:
          return "bg-primary-light ";
      }
    },
  },
  methods: {
    icon() {
      return require(`@/assets/images/base/icons/${this.type}.svg`);
    },
  },
};
</script>
